<div class="p-inputgroup m-l-md d-none d-sm-inline">
  <form role="form" (ngSubmit)="search($event, op)" class="d-inline">
    <input type="text" pInputText [(ngModel)]="searchText" placeholder="{{'Help.textoAyuda' | translate}}"
      [ngModelOptions]="{ standalone: true }" class="w-50" tabindex="1000" autocomplete="off" />
    <button pButton type="submit" icon="fas fa-question" class="p-button-warn d-inline" (click)="search($event, op)"
      tabindex="1001" type="button"></button>
  </form>
</div>
<p-overlayPanel #op [appendTo]="'body'" [style]="{ 'max-width': '500px' }" [dismissable]="false" [showCloseIcon]="true">
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="row m-t-xs">
      <div class="col-12">
        <span class="m-xs" *ngIf="this.searching" class="leyenda">
          <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Help.searching' | translate}} </span>
      </div>
    </div>
    <plyca-helpElementResult #resultPanel></plyca-helpElementResult>
  </p-scrollPanel>
</p-overlayPanel>